import { render, staticRenderFns } from "./CommercialReports.vue?vue&type=template&id=244d4ca8&scoped=true"
import script from "./CommercialReports.vue?vue&type=script&lang=js"
export * from "./CommercialReports.vue?vue&type=script&lang=js"
import style0 from "./CommercialReports.vue?vue&type=style&index=0&id=244d4ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d4ca8",
  null
  
)

export default component.exports